export default __webpack_public_path__ + "static/media/CFL.d3a7da95.png";